export const ONE_APP_CLIENT = "oneApp" as const;

export function getOneAppRequest() {
  return {
    clientName: ONE_APP_CLIENT,
  };
}
